import React from 'react';
import { PlatformKaiProvider } from './PlatformKaiContext';
import PlatformKaiPanel from './PlatformKaiPanel';

/**
 * Mount once inside authenticated shell layout (next to Header).
 */
export function PlatformKaiHost({ defaultServiceKey, children }) {
  return (
    <PlatformKaiProvider defaultServiceKey={defaultServiceKey}>
      {children}
      <PlatformKaiPanel />
    </PlatformKaiProvider>
  );
}

export default PlatformKaiHost;
